import React, { Component } from 'react'
import { isFetching } from 'utils/redux/fetching'
import { connect } from 'react-redux'
import { reduxForm, formValueSelector } from 'redux-form'
import { calculateRate, calculateCryptoRate, switchCurrencies, resetRate, resetCalculator } from 'redux/actions/actions'
import { fetchCryptoCurrencies } from 'redux/actions/cryptoCurrencies'
import { fetchCurrencies } from 'redux/actions/currencies'
import Loader from 'components/Loader'
import Calculator from 'components/Calculator'
import { buildInitials } from 'utils/redux/helpers'

class CalculatorContainer extends Component {
	constructor(props) {
		super(props)
		// Set currentMode to be the one chosen
		this.state = {
			currentMode: props.selectedMode
		}
	}

	static getDerivedStateFromProps(nextProps, prevState) {
		// Fetch currencies here because we cannot use
		// both getDerivedStateFromProps and componentWillMount
		// Don't move it to the mode check below, since we need
		// to fetch entities on `componentWillMount`
		const { dispatch } = nextProps
		dispatch(fetchCurrencies())
		dispatch(fetchCryptoCurrencies())

		// Check if modes have been switched and update state if so
		if (nextProps.selectedMode !== prevState.currentMode) {

			// Reset calculator and reinitialize it when switched modes
			dispatch(resetCalculator())

			// Set the `currentMode` in the state to be the new one chosen
			return {
				currentMode: nextProps.selectedMode
			}
		}

		// If there is no switch between modes, don't update state
		return null
	}

	render () {
		if (this.props.isFetching) return <Loader />

		return <Calculator {...this.props} />
	}
}

const mapStateToProps = (state, props) => {

	const { currencies, cryptoCurrencies } = state
	const { currencyParam } = props

	if (isFetching([currencies, cryptoCurrencies])) return { isFetching: true }

	// Add BGN to the currencies list
	let currenciesList = [{
		id: 999,
		name: 'Български лев',
		abbreviature: 'BGN',
		flag: '/flags/bgn.png',
	}, ...currencies.data,]

	const isMonetary = props.selectedMode === 'monetary'
	// `isSwitched` is a flag that shows if the user has clicked the switch button
	// and if the currencies lists should be reversed
	const { isSwitched, toCurrency, fromCurrency } = state.calculatedRate
	const fromCurrencyList = isMonetary ? currenciesList : cryptoCurrencies.data
	const toCurrencyList = currenciesList
	let total = state.calculatedRate.total || null
	if (total) {
		total = isMonetary ? parseFloat(total) : parseFloat(total).toFixed(2)
	}

	return {
		from: isSwitched ? toCurrencyList : fromCurrencyList,
		to: isSwitched ? fromCurrencyList : toCurrencyList,
		total,
		initialValues: {
			fromQuantity: 1,
			fromCurrency: isMonetary
				? fromCurrency || buildInitials(fromCurrencyList, 'BGN')
				: fromCurrency || buildInitials(fromCurrencyList, currencyParam || 'BTC', true),
			toCurrency: isMonetary
				? toCurrency || buildInitials(toCurrencyList, currencyParam || 'EUR')
				: toCurrency || buildInitials(toCurrencyList, 'BGN')
		}
	}
}

const mapDispatchToProps = (dispatch, props) => {
	let delay
	return {
		onChange: () => {
			clearTimeout(delay)
			// Set timeout so that we don't send request each time the user presses a key
			// to update the value in the input. This way we wait for the user to input
			// the whole number and send only one request to the server
			delay = setTimeout(() => dispatch((dispatch, getState) => {
				const state = getState()
				const { isSwitched } = state.calculatedRate
				const selector = formValueSelector('calculatorForm')
				const values = selector(state, 'fromQuantity', 'fromCurrency', 'toCurrency')
				const data = {
					amount: values.fromQuantity,
					toCurrency: values.toCurrency,
					fromCurrency: values.fromCurrency,
					isSwitched
				}
				// Check if all three fields of the calculator have values
				if(data.amount === '' || data.toCurrency.length === 0 || data.fromCurrency.length === 0)  {
					// If not, reset total value of the calculator
					dispatch(resetRate())
				} else {
					// If all three fields have values, calculate rate
					// depending on selected mode - `crypto` or `monetary`
					if(props.selectedMode === 'monetary') {
						dispatch(calculateRate(data))
					} else {
						dispatch(calculateCryptoRate(data))
					}
				}
			}), 600)
		},
		switchCurrencies: () => {
			clearTimeout(delay)
			delay = setTimeout(() => dispatch(switchCurrencies(props.selectedMode)), 600)
		},
		resetCalculator: () => {
			dispatch(resetCalculator())
		}
	}
}

export default connect(mapStateToProps, mapDispatchToProps)(reduxForm({
	form: 'calculatorForm',
	enableReinitialize: true
})(CalculatorContainer))
